import { Box, Typography, useMediaQuery } from '@mui/material'
import React from 'react'

function Expertise() {
   const isMdScreen = useMediaQuery("(max-width:1200px)");
      const isXsScreen = useMediaQuery("(max-width:600px)");
  return (
    <section id="expertise" style={{  height: isMdScreen ? "auto" : "100vh", paddingTop: isMdScreen ? "20px": 0 ,paddingBottom : isMdScreen ? "20px": 0 ,display:"flex",alignItems:"center",    background: "linear-gradient(124deg, rgba(0, 0, 0, 1) 50%, rgba(128, 0, 128, 0.6) 100%)"}}>
      <Box 
        display="flex" 
        justifyContent="center" 
        alignItems="center" 
        flexDirection="column"
        width={"100%"}
      >
        
        <Typography variant="h4" sx={{ color: "white", fontWeight: "bold", mb: 3 }}>
          What Do I Do?
        </Typography>

        <Box 
          display="flex"
          justifyContent="center"
          alignItems="center"
          flexWrap="wrap"
          gap={3}
          sx={{ width: isXsScreen ? "80%" : "90%", marginTop: 1,height:"100%"}}
        >
          {[
            { 
              img: "/images/Frontend.png", 
              title: "Front-End Development", 
              text: "I can build the frontend of web applications using React or Angular. With React, I create dynamic, performance-focused, and reusable components, while Angular allows me to build robust, scalable applications with its comprehensive tools and modular structure. Whether you need a flexible UI or a feature-rich app, I can deliver user-friendly and efficient frontend solutions." 
            },
            { 
              img: "/images/Backend.png", 
              title: "Back-End Development", 
              text: "I specialize in building backend services using .NET Core to create efficient and scalable REST APIs. With .NET Core, I develop high-performance, secure APIs that integrate seamlessly with databases and third-party services. Whether you need to handle complex data or ensure smooth user interactions, I can deliver reliable backend solutions tailored to your application’s needs." 
            },
            // { 
            //   img: "/images/UIUX.png", 
            //   title: "UI/UX Design", 
            //   text: "I create intuitive and visually appealing UI designs using Figma. With Figma, I design user interfaces that are both user-friendly and responsive, ensuring a seamless experience across devices. Whether you need modern, clean designs or a more complex layout, I can deliver high-quality, collaborative designs that align with your vision." 
            // },
            { 
              img: "/images/project-management.png", 
              title: "Project Management", 
              text: "I manage projects efficiently using Agile Scrum methodology. With a focus on collaboration and iterative development, I ensure smooth project execution, timely delivery, client satisfaction and adaptability to changing requirements. By implementing Scrum principles, I enhance team productivity and maintain transparency throughout the development lifecycle." 
            }
          ].map((item, index) => (
            <Box
              key={index}
              sx={{
                border: "1px solid rgb(175, 169, 169)",
                boxShadow: "0px 0px 15px rgba(255, 255, 255, 0.3)",
                borderRadius: "12px",
                padding: "20px",
                textAlign: "center",
                flex: "1 1 300px",
                minWidth: "280px",
                maxWidth: "400px",
                height: "auto",
                backgroundColor: "rgba(255, 255, 255, 0.1)"
              }}
            >
              <img src={item.img} alt={item.title} style={{ width: "80px", height: "70px" }} />
              <Typography variant="h6" sx={{ color: "white", fontWeight: "bold", pt: 1 }}>
                {item.title}
              </Typography>
              <Typography sx={{ color: "white", pt: 1, fontSize: "14px", textAlign: "justify" }}>
                {item.text}
              </Typography>
            </Box>
          ))}
        </Box>


      </Box>
    </section>
  )
}

export default Expertise;
